__turbopack_context__.v({
  "indicator": "PZadlW_indicator",
  "label": "PZadlW_label",
  "list": "PZadlW_list",
  "pill": "PZadlW_pill",
  "root": "PZadlW_root",
  "tab": "PZadlW_tab",
});
